export default __webpack_public_path__ + "static/media/aboutUs3.d6d1cf64.webp";